import request from '@/utils/request'
let baseUrl = "auth/competition/task"
export function list(compId){
    return request({
        url: baseUrl+"/list",
        method: 'get',
        params: {
            compId: compId
        }
    })
}

export function get(compId,stageId){
    return request({
        url: baseUrl+"/get",
        method: 'get',
        params: {
            compId: compId,
            stageId: stageId
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/task.js